var map = {
	"./icon_animal_plants.svg": 2785,
	"./icon_artmedia.svg": 2786,
	"./icon_beautyfashion.svg": 2787,
	"./icon_biochem.svg": 2788,
	"./icon_communication.svg": 2789,
	"./icon_construction.svg": 2790,
	"./icon_finance.svg": 2791,
	"./icon_food.svg": 2792,
	"./icon_health.svg": 2793,
	"./icon_house.svg": 2794,
	"./icon_language.svg": 2795,
	"./icon_mechatronics.svg": 2796,
	"./icon_metal.svg": 2797,
	"./icon_outside.svg": 2798,
	"./icon_programming.svg": 2799,
	"./icon_service.svg": 2800,
	"./icon_social.svg": 2801,
	"./icon_sports.svg": 2802,
	"./icon_stone_wood.svg": 2803,
	"./icon_sustainable.svg": 2804,
	"./icon_tourism.svg": 2805,
	"./icon_trade.svg": 2806,
	"./icon_transport.svg": 2807,
	"./icon_vehicles.svg": 2808
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2784;